module.exports = __webpack_public_path__ + "img/xf_pic.30643ea3.png";